module.exports = __webpack_public_path__ + "static/media/Bot_Nova_Mensaje.348568d6.png";